import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtyTwoPreLogin',
    name: 'IFPageOneHSixtyTwoPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtyTwoLogin' ||
        from.path === '/IFPageOneHSixtyTwoLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtyTwoLogin',
    name: 'pageOneHSixtyTwoLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/login.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoLoginLoading',
    name: 'pageOneHSixtyTwoLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoLeaveInfo',
    name: 'pageOneHSixtyTwoLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoResult',
    name: 'pageOneHSixtyTwoResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/result.vue'),
  },
  {
    path: '/IFPageOneHSixtyTwoLoading',
    name: 'pageOneHSixtyTwoLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtyTwoLoginSecond',
    name: 'pageOneHSixtyTwoLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtyTwoGuide',
    name: 'pageOneHSixtyTwoLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHSixtyTwoCar',
    name: 'pageOneHSixtyTwoCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtyTwoCarDetails',
    name: 'pageOneHSixtyTwoCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHSixtyTwoBlank',
    name: 'pageOneHSixtyTwoBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtyTwo/blank.vue'),
    meta: {
      title: projectName,
    },
  },
];
